import { memo, useCallback, useState } from 'react'
import PlayButton from '@/components/elements/buttons/playButton'
import CustomImage from '@/components/elements/images/image'
import { VideoPlayer } from '@/components/elements/video/videoPlayer'
import { useRouter } from 'next/router'
import { createGetSeminarsVideoEndpoint } from 'utils/endpoints'

const SeminarDetailsVideoContainer = ({
  video,
  cover,
  subtitles,
  hidePlayButton = false,
  playOnHover = false
}) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const { query } = useRouter()

  const videoUrl = video && createGetSeminarsVideoEndpoint(video)

  const onClick = useCallback(() => setIsPlaying(true), [])
  const onMouseEnter = () => playOnHover && setIsPlaying(true)
  const onMouseLeave = () => playOnHover && setIsPlaying(false)

  if (!videoUrl) return null

  return (
    <div
      className="seminar-details-video-container"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="seminar-details-card-cover">
        {!isPlaying && (
          <>
            {!hidePlayButton && (
              <PlayButton onClick={onClick} className="thumbnail-play-icon" />
            )}
            {cover && (
              <div className="seminar-details-card-cover-image">
                <CustomImage
                  media={cover}
                  layout="fill"
                  objectPosition="center"
                  objectFit="cover"
                  priority
                />
              </div>
            )}
          </>
        )}
        <VideoPlayer
          url={videoUrl}
          controls={!playOnHover}
          playing={isPlaying}
          muted={playOnHover}
          width="100%"
          height="auto"
          startTime={query?.t || 0}
          subtitles={subtitles}
        />
      </div>
    </div>
  )
}

export default memo(SeminarDetailsVideoContainer)
